{
  "guideContent": {
    "insert": "Insert content",
    "insertHeader": "Header",
    "insertText": "Text",
    "insertStep": "Step",
    "headerPlaceholder": "Section title",
    "textPlaceholder": "Write some text...",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "delete": "Delete"
  },
  "common": {
    "confirm": "Confirm",
    "cancel": "Cancel",
    "previous": "Previous",
    "next": "Next"
  },
  "auth": {
    "login": {
      "title": "Sign in",
      "email": "Email",
      "password": "Password",
      "submit": "Sign in",
      "submitting": "Signing in...",
      "noAccount": "Don't have an account?",
      "signupLink": "Create account",
      "error": "Invalid email or password.",
      "googleButton": "Sign in with Google",
      "divider": "or"
    },
    "extension_callback": {
      "title": "Sign-in complete!",
      "description": "You can close this tab and return to the extension."
    },
    "signup": {
      "title": "Create account",
      "name": "Name",
      "email": "Email",
      "password": "Password",
      "passwordConfirmation": "Confirm password",
      "submit": "Create account",
      "submitting": "Creating...",
      "hasAccount": "Already have an account?",
      "loginLink": "Sign in",
      "googleButton": "Sign up with Google",
      "divider": "or"
    }
  },
  "home": {
    "welcome": "Welcome to Instruo",
    "subtitle": "Your workspace is ready."
  },
  "nav": {
    "guides": "Guides",
    "company": "Company",
    "billing": "Billing",
    "aiWriters": "AI Writers",
    "settings": "Settings",
    "logout": "Sign out",
    "installExtension": "Install Extension"
  },
  "guides": {
    "index": {
      "title": "My Guides",
      "newGuide": "New Guide",
      "empty": "You haven't created any guides yet.",
      "emptyAction": "Create your first guide",
      "gettingStarted": {
        "title": "Create your first guide in 3 steps",
        "subtitle": "Instruo turns your screen recordings into polished step-by-step documentation.",
        "step1Title": "Install the Browser Extension",
        "step1Description": "Add the Instruo Recorder to your browser. It captures screenshots and clicks as you work.",
        "step1DescriptionUnsupported": "The Instruo Recorder is available for Chrome and Edge. Open this page in a supported browser to install it.",
        "step1Unsupported": "Requires Chrome or Edge",
        "step1Cta": "Install Extension",
        "step1ImageAlt": "The Instruo Recorder extension page on the Chrome Web Store with the install button",
        "step2Title": "Record your workflow",
        "step2Description": "Click record, perform your task, and narrate if you'd like. The extension captures everything.",
        "step2ImageAlt": "The Instruo Recorder extension recording a workflow and capturing each action automatically",
        "step3Title": "AI polishes your guide",
        "step3Description": "Instruo's AI Writer turns your recording into a clear, professional guide — ready to share.",
        "step3ImageAlt": "A finished Instruo guide with AI-generated steps and descriptions",
        "manualCreate": "or create a guide manually"
      },
      "upgradeDescription": "You've reached the guide limit on the Free plan. Upgrade to create unlimited guides.",
      "allGuides": "All",
      "myGuides": "Personal",
      "companyGuides": "Company",
      "searchPlaceholder": "Search guides...",
      "sortPosition": "Custom order",
      "sortTitleAsc": "Title A-Z",
      "sortTitleDesc": "Title Z-A",
      "sortNewest": "Newest first",
      "sortOldest": "Oldest first",
      "noResults": "No guides found.",
      "updatedAgo": "Updated {time}",
      "creating": "Creating..."
    },
    "defaultTitle": "Untitled Guide",
    "show": {
      "edit": "Edit",
      "delete": "Delete",
      "deleteConfirm": "This guide and all its steps will be permanently deleted.",
      "deleteTitle": "Delete guide?",
      "backToGuides": "Back to guides",
      "publicLink": "Public link",
      "copyLink": "Copy link",
      "linkCopied": "Copied!",
      "viewGuide": "View guide",
      "exportPdf": "Export PDF",
      "editTitle": "Click to edit title"
    },
    "edit": {
      "title": "Edit Guide",
      "companyLabel": "Company",
      "companyNone": "None (personal)",
      "visibilityLabel": "Visibility",
      "visibilityPrivate": "Private",
      "visibilityCompany": "Company",
      "visibilityPublic": "Public",
      "visibilityHeading": "Who can see this guide?",
      "visibilityPrivateHelp": "Only you can see this guide.",
      "visibilityPublicHelp": "Anyone with the link can see it.",
      "visibilityPortalHeading": "Company portal",
      "visibilityPortalPagePublic": "Public",
      "visibilityPortalPagePrivate": "Members only",
      "visibilityPortalEmpty": "Create portal pages in your company settings.",
      "visibilityPortalUpsell": "Available on the Business plan.",
      "submit": "Save",
      "submitting": "Saving...",
      "cancel": "Cancel",
      "saving": "Saving...",
      "saved": "Saved",
      "backToGuide": "View guide",
      "viewVideo": "View video"
    },
    "visibility": {
      "private": "Private",
      "company": "Company",
      "public": "Public"
    },
    "card": {
      "shareLink": "Share link"
    }
  },
  "steps": {
    "sectionTitle": "Steps",
    "defaultTitle": "Untitled Step",
    "noteLabel": "Note",
    "notePlaceholder": "Click to add a note",
    "saved": "Saved",
    "clickToEdit": "Click to edit",
    "empty": "No steps yet. Add your first step to get started.",
    "addStep": "Add Step",
    "deleteTitle": "Delete step?",
    "deleteConfirm": "This step will be permanently deleted.",
    "screenshot": {
      "label": "Screenshot",
      "upload": "Click, drag and drop, or paste (Ctrl+V)",
      "hint": "PNG, JPEG, WebP or GIF (max 10 MB)",
      "remove": "Remove screenshot",
      "edit": "Pixelate sensitive areas",
      "editHint": "Drag to create a region",
      "editLoadFailed": "Couldn't load the screenshot for editing.",
      "editSaveFailed": "Save failed. Try again.",
      "restoreOriginal": "Restore original",
      "restoreOriginalTitle": "Restore the original screenshot?",
      "restoreOriginalConfirm": "The pixelated version will be replaced with the un-edited original.",
      "restoreOriginalPublicWarning": "This guide is shared publicly. The original screenshot will become visible to everyone with the link."
    },
    "click": {
      "manage": "Manage click",
      "placeHint": "Click to place indicator",
      "editHint": "Click to move, click indicator to remove"
    },
    "reorder": {
      "dragHandle": "Drag to reorder"
    },
    "actions": {
      "menu": "Step actions",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "duplicate": "Duplicate",
      "mergeDown": "Merge down",
      "undoMerge": "Undo merge",
      "delete": "Delete"
    }
  },
  "profile": {
    "title": "Settings",
    "nameLabel": "Name",
    "emailLabel": "Email",
    "currentPasswordLabel": "Current password",
    "newPasswordLabel": "New password",
    "confirmPasswordLabel": "Confirm new password",
    "languageLabel": "Language",
    "submit": "Save changes",
    "submitting": "Saving...",
    "changePassword": "Change password",
    "passwordHint": "Leave blank to keep your current password.",
    "apiToken": {
      "title": "API Token",
      "description": "Use this token to authenticate the Chrome extension.",
      "generate": "Generate token",
      "revoke": "Revoke token",
      "revokeConfirm": "Revoke this token? The Chrome extension will stop working until you generate a new one.",
      "revokeTitle": "Revoke API token?",
      "active": "You have an active API token.",
      "newToken": "Copy your token now — it won't be shown again:",
      "copied": "Copied!"
    },
    "googleLinked": "Signed in with Google",
    "avatar": {
      "title": "Avatar",
      "upload": "Upload photo",
      "change": "Change photo",
      "remove": "Remove",
      "tooLarge": "File too large. Max 5MB.",
      "invalidType": "Invalid file type. Use PNG, JPEG, WebP, or GIF."
    }
  },
  "editor": {
    "bold": "Bold",
    "italic": "Italic",
    "strike": "Strikethrough",
    "heading": "Heading",
    "bulletList": "Bullet list",
    "orderedList": "Numbered list",
    "blockquote": "Quote",
    "code": "Code",
    "link": "Link",
    "undo": "Undo",
    "redo": "Redo",
    "linkPrompt": "Enter URL"
  },
  "aiPolish": {
    "polishAll": "Polish Guide",
    "polishedState": "Polished",
    "polishSettingsAriaLabel": "Polish options",
    "polishSettingsTooltip": "Choose AI Writer and narration influence",
    "polishAllTooltip": "Use AI to rewrite step titles and descriptions in the style of the selected AI Writer.",
    "polishAllInProgressTooltip": "AI is polishing this guide...",
    "polishAllNoChangesTooltip": "The guide is already polished — click to polish again (e.g. a different AI Writer or narration influence).",
    "polishingAll": "Polishing guide...",
    "polishAllPreviewTitle": "AI Polish — Review Changes",
    "guideTitle": "Guide Title",
    "acceptSelected": "Accept Selected",
    "discard": "Discard",
    "original": "Original",
    "polished": "Polished",
    "originalTitle": "Original Title",
    "polishedTitle": "Polished Title",
    "originalDescription": "Original Description",
    "polishedDescription": "Polished Description"
  },
  "narration": {
    "processing": "Processing narration...",
    "failed": "Narration processing failed",
    "retry": "Retry"
  },
  "image": {
    "loading": "Loading image...",
    "loadFailed": "Image unavailable"
  },
  "plan": {
    "free": "Free",
    "pro": "Pro",
    "business": "Business",
    "badge": "{plan} Plan",
    "upgradeTitle": "Upgrade your plan",
    "upgradeDescription": "Unlock more features and higher limits with a paid plan.",
    "upgradeButton": "Upgrade"
  },
  "pricing": {
    "title": "Choose your plan",
    "subtitle": "Choose the right plan for your team.",
    "monthly": "Monthly",
    "annual": "Annual",
    "annualDiscount": "Save 20%",
    "month": "mo",
    "year": "year",
    "custom": "Custom",
    "billedAnnually": "{total}/year billed annually",
    "popular": "Most popular",
    "allPlansInclude": "All plans include",
    "currentPlan": "Current plan",
    "subscribe": "Subscribe",
    "upgrade": "Upgrade",
    "downgrade": "Downgrade",
    "freeTier": "Free forever",
    "error": "Something went wrong. Please try again.",
    "features": {
      "seatsIncluded": "{count} members included",
      "proGuides": "Unlimited guides",
      "unlimitedSteps": "Unlimited steps per guide",
      "pdfExport": "PDF export",
      "analytics": "Guide analytics",
      "videoExport": "Video export",
      "everythingInPro": "Everything in Pro",
      "companyPortal": "Company portal access",
      "customAiWriters": "Custom AI Writers"
    }
  },
  "checkout": {
    "title": "Complete payment",
    "submit": "Subscribe now",
    "processing": "Processing...",
    "confirmed": "Payment confirmed!",
    "redirecting": "Updating your plan...",
    "havePromoCode": "Have a promo code?",
    "promoCodeLabel": "Promo code",
    "promoCodePlaceholder": "Enter code",
    "promoApply": "Apply",
    "promoInvalid": "Invalid or expired promo code.",
    "promoOff": "off",
    "promoMonths": "months",
    "promoForever": "forever",
    "promoApplied": "Discount applied",
    "promoRemove": "Remove",
    "summaryCycleMonthly": "Monthly",
    "summaryCycleAnnual": "Annual",
    "summaryTotal": "Total to charge",
    "summarySeats": "{count} seats",
    "summaryDiscountApplied": "Promo applied"
  },
  "billing": {
    "title": "Billing",
    "currentPlan": "Current plan",
    "status": "Status",
    "statusActive": "Active",
    "statusPastDue": "Past due",
    "statusCanceled": "Canceled",
    "statusIncomplete": "Processing",
    "statusTrialing": "Free trial",
    "nextInvoice": "Next invoice on",
    "changePlan": "Change plan",
    "changePlanConfirmTitle": "Change plan?",
    "changePlanConfirmMessage": "Your plan will be changed to {plan}. The difference will be prorated.",
    "changePlanConfirm": "Confirm change",
    "cancelPlan": "Cancel plan",
    "reactivate": "Reactivate",
    "updatePayment": "Update payment method",
    "cancelConfirmTitle": "Cancel subscription?",
    "cancelConfirmMessage": "You'll keep access until the end of your billing period, then your plan will revert to Free.",
    "canceling": "Canceling...",
    "reactivating": "Reactivating...",
    "cancelAtPeriodEnd": "Your subscription to the {plan} plan will be effective until {date}.",
    "pastDueBanner": "Payment failed — please update your payment method.",
    "trialBanner": "{days} days remaining in your trial — subscribe now to keep your guides.",
    "subscribeCta": "Subscribe now",
    "trialStatus": "Your trial",
    "trialDaysLeft": "{days} days remaining",
    "manageSeats": "Manage members",
    "manageSeatModal": "Manage Members",
    "seatsLabel": "Members",
    "seatsIncludedInPlan": "members included in your plan",
    "seatsUsedByTeam": "members active in your team",
    "addSeatsButton": "Add {count} Member(s) ({price})",
    "removeSeatsButton": "Remove {count} Member(s)",
    "seatUsageIndicator": "You are using {used} of {total} seats",
    "buyMoreSeats": "Buy more seats",
    "seatsDone": "Done",
    "processing": "Processing...",
    "nextCharge": "Next charge",
    "statusCanceling": "Canceling",
    "invoiceHistory": "Invoice history",
    "invoiceDate": "Date",
    "invoiceAmount": "Amount",
    "invoiceStatus": "Status",
    "viewInvoice": "View",
    "noInvoices": "No invoices yet.",
    "invoicePaid": "Paid",
    "giftedBanner": "Your free Business access expires on {date}.",
    "giftedBannerCta": "Subscribe to keep your Business features after this date.",
    "giftedTag": "Free gift",
    "giftedSubscribe": "Subscribe now"
  },
  "redeem": {
    "title": "Redeem Code",
    "subtitle": "Activate your free Business plan",
    "planLabel": "Plan",
    "durationLabel": "Duration",
    "durationDays": "{days} days",
    "activateButton": "Activate Business Plan",
    "activating": "Activating...",
    "invalidCode": "This code is invalid or does not exist.",
    "alreadyRedeemed": "This code has already been redeemed.",
    "inactive": "This code is no longer active.",
    "alreadySubscribed": "You already have an active subscription.",
    "noCode": "No redemption code provided."
  },
  "confirmation": {
    "banner": "Please confirm your email to fully access the app. Check your inbox for the confirmation link.",
    "resendLink": "Resend email"
  },
  "companies": {
    "show": {
      "title": "Company Settings",
      "tabGeneral": "General",
      "tabMembers": "Members",
      "tabPortal": "Portal",
      "nameLabel": "Company name",
      "save": "Save",
      "saving": "Saving...",
      "deleteCompany": "Delete company",
      "deleteTitle": "Delete company?",
      "deleteConfirm": "All guides will revert to private. This cannot be undone.",
      "members": "Members",
      "owner": "Owner",
      "member": "Member",
      "removeMember": "Remove",
      "removeTitle": "Remove member?",
      "removeConfirm": "This member will lose access to company guides.",
      "leaveCompany": "Leave company",
      "leaveTitle": "Leave company?",
      "leaveConfirm": "You will lose access to this company's guides.",
      "invitations": "Invite Members",
      "saved": "Saved",
      "inviteLabel": "Email address",
      "invitePlaceholder": "colleague@company.com",
      "invite": "Send invite",
      "inviting": "Sending...",
      "revokeInvite": "Revoke",
      "revokeTitle": "Revoke invitation?",
      "revokeConfirm": "This invitation link will no longer work.",
      "resendInvite": "Resend",
      "expiresAt": "Expires {date}",
      "noInvitations": "Sent invitations will appear here until accepted.",
      "invitationStatus": {
        "pending": "Pending",
        "accepted": "Accepted",
        "expired": "Expired"
      }
    },
    "locked": {
      "title": "Company Portal",
      "description": "Upgrade to the Business plan to unlock your company portal and invite members.",
      "upgrade": "Upgrade to Business"
    }
  },
  "invitations": {
    "accept": {
      "title": "Join Company",
      "message": "You've been invited to join {companyName}.",
      "submit": "Join Company",
      "submitting": "Joining...",
      "cancel": "Decline"
    },
    "register": {
      "title": "Create your account",
      "subtitle": "Set up your account to join {companyName}.",
      "submit": "Create account & join company",
      "submitting": "Creating..."
    }
  },
  "trialExpired": {
    "title": "Your trial has ended",
    "description": "Subscribe to a plan to continue using Instruo and access your guides.",
    "subscriptionExpiredTitle": "Your subscription has expired",
    "subscriptionExpiredDescription": "Renew your subscription to continue using Instruo.",
    "dataPreserved": "Your data is safe and will be available when you subscribe.",
    "subscribeCta": "Subscribe now"
  },
  "errors": {
    "notFound": {
      "title": "Page not found",
      "description": "The page you're looking for doesn't exist or has been moved.",
      "backHome": "Go to homepage"
    },
    "fallback": {
      "title": "Something went wrong",
      "description": "We hit an unexpected error. Our team has been notified and we're working on a fix.",
      "reload": "Reload page"
    }
  },
  "publicGuide": {
    "by": "by",
    "step": "Step",
    "steps": "{count} steps",
    "stepsSingular": "1 step",
    "poweredBy": "Built with",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "expandImage": "View full image",
    "watchVideo": "Watch video"
  },
  "portal": {
    "title": "Guides",
    "guidesTitle": "Guides",
    "guidesDescription": "Browse guides from {company}",
    "noGuides": "No guides published yet",
    "stepSingular": "1 step",
    "steps": "{count} steps",
    "backToGuides": "Back to guides",
    "poweredBy": "Powered by",
    "portalSlugLabel": "Portal URL",
    "portalSlugPlaceholder": "your-company",
    "portalSlugHelp": "Your portal will be at:",
    "portalSlugSave": "Save",
    "portalSection": "Company Portal",
    "portalSectionDescription": "Give your company a public URL where anyone can browse your published guides.",
    "portalUpgradeRequired": "Upgrade to Business to enable your company portal.",
    "portalActive": "Your portal is live at:",
    "portalDisabled": "Portal is disabled — upgrade to Business to re-enable.",
    "visibilityLabel": "Portal access",
    "visibilityPublic": "Public",
    "visibilityPrivate": "Private",
    "visibilityPublicHelp": "Anyone with the link can browse your guides.",
    "visibilityPrivateHelp": "Only company members can access the portal.",
    "searchPlaceholder": "Search guides...",
    "sortNewest": "Newest",
    "sortOldest": "Oldest",
    "sortTitleAsc": "Title A–Z",
    "sortTitleDesc": "Title Z–A",
    "noResults": "No guides match your search",
    "shareLink": "Copy link",
    "linkCopied": "Link copied!",
    "home": "Home",
    "noGuidesInSection": "No guides in this section yet",
    "portalPagesSection": "Portal Pages",
    "portalPagesSectionDescription": "Manage your portal pages and organize guides into sections.",
    "addSubpage": "Add subpage",
    "subpageNameLabel": "Page name",
    "subpageNamePlaceholder": "e.g., Training",
    "subpageSlugLabel": "URL slug",
    "subpageVisibility": "Visibility",
    "subpagePublic": "Public",
    "subpagePrivate": "Members only",
    "subpageGuideCount": "{count} guides",
    "subpageGuideCountSingular": "1 guide",
    "subpageGuideCountZero": "No guides",
    "deleteSubpage": "Delete",
    "deleteSubpageTitle": "Delete subpage",
    "deleteSubpageConfirm": "This will make {count} guides private. Are you sure?",
    "deleteSubpageConfirmEmpty": "Are you sure you want to delete this subpage?",
    "editSubpage": "Edit",
    "saveSubpage": "Save",
    "cancelEdit": "Cancel",
    "brandingSection": "Branding",
    "brandingSectionDescription": "Customize your portal's look and feel with a logo, colors, and images.",
    "logoLabel": "Logo",
    "logoHint": "PNG, JPEG, WebP, or GIF. Max 2MB.",
    "coverImageLabel": "Cover Image",
    "coverImageHint": "Displayed as the header background. Max 2MB.",
    "faviconLabel": "Favicon",
    "faviconHint": "PNG only. Max 2MB.",
    "brandColorLabel": "Brand Color",
    "brandColorHint": "This color will be used for links, buttons, and accents on the portal.",
    "brandColorPlaceholder": "#3b82f6",
    "brandColorReset": "Reset to default",
    "contrastWarning": "This color may have low contrast on light backgrounds.",
    "uploadImage": "Upload image",
    "removeImage": "Remove",
    "brandingSave": "Save branding",
    "brandingSaved": "Branding saved!"
  },
  "aiWriterPage": {
    "title": "AI Writers",
    "description": "Choose your default AI Writer. This controls how the AI polishes your guide content — the audience it writes for, the tone it uses, and how much detail it includes.",
    "audience": "Audience",
    "tone": "Tone",
    "detail": "Detail Level",
    "default": "Default",
    "selected": "Selected",
    "setDefault": "Set as Default",
    "customWriters": "Custom Writers",
    "createCustom": "Create AI Writer",
    "editCustom": "Edit",
    "deleteCustom": "Delete",
    "customName": "Name",
    "customAudience": "Audience",
    "customTone": "Tone",
    "customDetail": "Detail Level",
    "customNamePlaceholder": "e.g., Compliance Writer",
    "customAudiencePlaceholder": "Describe who will read the guides...",
    "customTonePlaceholder": "Describe the tone and voice...",
    "customDetailPlaceholder": "Describe the level of detail...",
    "saveCustom": "Save",
    "cancelCustom": "Cancel",
    "deleteConfirm": "Are you sure you want to delete this AI Writer?",
    "businessOnly": "Custom AI Writers are available on the Business plan.",
    "writerSubtitle": {
      "standard": "Balanced tone for general documentation",
      "quick_reference": "Concise, action-only steps for quick lookups",
      "customer_support": "Friendly, step-by-step for external users",
      "training": "Detailed, instructional for learning processes"
    },
    "writers": {
      "standard": {
        "audience": "Write for team members familiar with this tool. Use domain-specific terminology without explanation. Assume familiarity with the interface.",
        "tone": "Use a neutral, professional tone. Be clear and direct without being stiff or overly casual.",
        "detail": "Use standard detail. 1–2 sentences per step description. Include brief explanations where they add clarity, but do not elaborate on obvious actions."
      },
      "quick_reference": {
        "audience": "Write for team members who already know this process and need a quick refresher. Assume full familiarity with the tool and terminology.",
        "tone": "Use a neutral, matter-of-fact tone. Be direct and efficient.",
        "detail": "Be concise. 1 sentence maximum per step description. State only the action to perform. Omit explanations, background context, and tips."
      },
      "customer_support": {
        "audience": "Write for customers or external users completing a task in your product. Use simple, supportive language. Avoid internal jargon.",
        "tone": "Use a friendly, supportive voice. Be patient and reassuring. Use second person and positive framing.",
        "detail": "Be thorough. 2–3 sentences per step description. Explain what the user will see at each step and what each action accomplishes."
      },
      "training": {
        "audience": "Write for people actively learning this process as part of training. Explain the purpose behind each step. Connect actions to outcomes.",
        "tone": "Use a neutral, instructional tone. Be clear and methodical like a textbook or training manual.",
        "detail": "Be thorough. 2–3 sentences per step description. Explain why each step matters and how it fits into the larger process."
      }
    }
  },
  "aiWriter": {
    "label": "AI Writer",
    "standard": "Standard",
    "quick_reference": "Quick Reference",
    "customer_support": "Customer Support",
    "training": "Training"
  },
  "narrationInfluence": {
    "label": "Narration influence",
    "hint": "How much the recorded narration shapes the polished descriptions.",
    "light": "Light",
    "lightHint": "Narration only adds small clarifying details.",
    "balanced": "Balanced",
    "balancedHint": "Uses narration to explain the why behind each step.",
    "heavy": "Heavy",
    "heavyHint": "Near-transcribes what was said, on the right step."
  },
  "interactive": {
    "guideTypeLabel": "Guide type",
    "guideTypeLinear": "Linear",
    "guideTypeInteractive": "Interactive",
    "branchLabel": "Branch",
    "decisionPoint": "Decision point",
    "selectBranch": "Select a path",
    "backToDecision": "Back to decision",
    "noStepsRecorded": "No steps recorded for this path",
    "missingScreenshot": "Missing screenshot",
    "pdfNotAvailable": "PDF export is not available for interactive guides yet",
    "breadcrumbStart": "Start",
    "splitIntoBranches": "Split into branches",
    "dragToMove": "Drag to move between branches",
    "clickToExpand": "Click to expand",
    "removeBranches": "Remove branches",
    "markedDecisionPoint": "Marked as decision point",
    "markAsDecisionPoint": "Mark as decision point",
    "unmarkDecisionPoint": "Unmark decision point"
  },
  "onboarding": {
    "step2": {
      "title": "Install the Browser Extension",
      "subtitle": "Record your screen and narrate — the extension captures everything.",
      "description": "The Instruo Recorder extension captures screenshots, clicks, and narration as you work — then turns it all into a polished guide automatically.",
      "installButton": "Install Extension"
    },
    "step3": {
      "title": "Choose your trial plan",
      "subtitle": "Try all features for 30 days. You can change anytime."
    },
    "plans": {
      "pro": {
        "name": "Pro",
        "description": "For independent professionals — unlimited guides, PDF and video export"
      },
      "business": {
        "name": "Business",
        "description": "For teams — everything in Pro + portal, analytics, and custom AI Writers"
      }
    },
    "loading": "Loading...",
    "continue": "Continue →",
    "startTrial": "Start free trial"
  },
  "feedback": {
    "button": "Give feedback",
    "title": "What's on your mind?",
    "placeholder": "Tell us what you think, report a bug, or suggest an improvement...",
    "attachScreenshot": "Attach screenshot",
    "submit": "Send",
    "thanks": "Thank you for your feedback!"
  },
  "survey": {
    "dismiss": "Dismiss",
    "first_guide_published": {
      "title": "How was the experience creating your first guide?",
      "placeholder": "Any suggestions? (optional)"
    }
  },
  "analytics": {
    "title": "Analytics",
    "totalVisits": "Total Visits",
    "completeViews": "Complete Views",
    "avgTimeSpent": "Avg. Time Spent",
    "videoViews": "Video Views",
    "viewer": "Viewer",
    "scrollPercentage": "Scroll %",
    "timeSpent": "Time Spent",
    "viewedAt": "Date / Time",
    "source": "Source",
    "anonymous": "Anonymous",
    "noViews": "No views yet. Share your guide to start tracking.",
    "privateGuideNotice": "This guide is private. Change visibility to public or company to start tracking views.",
    "companyTitle": "Company Analytics",
    "guideColumn": "Guide",
    "viewDetails": "View Details",
    "author": "Author",
    "totalVisitsHelp": "Total page loads across all visitors.",
    "completeViewsHelp": "Visitors who read the guide to the end (95%+ scroll).",
    "videoViewsHelp": "Visitors who watched the guide video.",
    "searchGuides": "Search guides...",
    "noResults": "No guides match your search.",
    "visibility": {
      "private_guide": "Private",
      "company": "Company",
      "public_guide": "Public"
    },
    "page": "Page",
    "of": "of",
    "previous": "Previous",
    "next": "Next",
    "seconds": "s",
    "minutes": "min",
    "upgradeTitle": "Analytics",
    "upgradeDescription": "Upgrade to Business to see who viewed your guides, how much they read, and more.",
    "upgradeButton": "Upgrade Plan"
  },
  "admin": {
    "users": {
      "title": "Admin · Users",
      "description": "Sign in as any user to debug, support, or verify their experience.",
      "searchPlaceholder": "Search by email or name…",
      "search": "Search",
      "clear": "Clear",
      "impersonate": "Impersonate",
      "empty": "No users match your search.",
      "tableEmail": "Email",
      "tableName": "Name",
      "tablePlan": "Plan",
      "tableStatus": "Status",
      "tableGuides": "Guides",
      "tableConfirmed": "Confirmed",
      "tableInvited": "Invited",
      "tableCreated": "Created",
      "tableActions": "Actions",
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {page} of {total}",
      "yes": "Yes",
      "no": "No",
      "status": {
        "paying": "Paying",
        "trialing": "Trialing",
        "locked": "Locked"
      }
    }
  },
  "impersonationBanner": {
    "label": "Impersonating {email}",
    "stop": "Stop impersonating"
  },
  "video": {
    "title": "Video",
    "generate": "Generate Video",
    "generating": "Generating video...",
    "processingDescription": "Your video is being generated. This may take a few minutes.",
    "ready": "Video ready",
    "failed": "Video generation failed.",
    "retry": "Try Again",
    "statusNotCreated": "Create your video",
    "statusCreating": "Generating video...",
    "statusCreated": "Video ready",
    "statusOutdated": "Video outdated",
    "statusFailed": "Video failed",
    "videoSettingsAriaLabel": "Video options",
    "videoSettingsTooltip": "Adjust video settings",
    "statusTooltipNotCreated": "Create a video from this guide's steps",
    "statusTooltipProcessing": "AI is generating the video",
    "statusTooltipReady": "Video matches the latest version of the guide",
    "statusTooltipUpdate": "Update the video with new settings",
    "statusTooltipStale": "Guide changed since last generation — click to update",
    "statusTooltipFailed": "Generation failed — click to retry",
    "download": "Download MP4",
    "noSteps": "Add steps with screenshots to your guide before generating a video.",
    "emptyTitle": "Turn your guide into a video",
    "emptyDescription": "AI narrates each step with a natural voice, showing your guide's screenshots and click indicators.",
    "viewGuide": "View the guide",
    "stepSingular": "step",
    "stepPlural": "steps",
    "outdated": "This video is outdated. Regenerate to reflect recent changes.",
    "regenerate": "Regenerate",
    "updateVideo": "Update video",
    "share": "Share",
    "copyLink": "Copy link",
    "linkCopied": "Copied!",
    "settings": {
      "title": "Video settings",
      "description": "Adjust how this video will be generated.",
      "showAuthorLabel": "Show the guide's author",
      "showAuthorHint": "When on, the intro card includes 'by {author}'.",
      "announceStepNumbersLabel": "Announce step numbers in the narration",
      "announceStepNumbersHint": "When on, the narration starts each step with '1.', '2.', etc.",
      "orientationLabel": "Orientation",
      "horizontal": "Horizontal",
      "horizontalHint": "16:9, great for screens and presentations.",
      "vertical": "Vertical",
      "verticalHint": "9:16, great for Instagram and social media.",
      "narrationSpeedLabel": "Narration speed",
      "narrationSpeedHint": "1× is the default pace. Higher values make the narration faster.",
      "voiceLabel": "Narrator",
      "voiceHint": "Choose the narration voice. Tap ▶ to hear a sample.",
      "preview": "Play sample",
      "voices": {
        "warm": "Female, warm",
        "soft": "Female, soft",
        "expressive": "Female, expressive",
        "deep": "Male, deep",
        "neutral": "Male, neutral",
        "calm": "Male, calm"
      },
      "cancel": "Cancel",
      "generate": "Generate video",
      "regenerate": "Regenerate"
    }
  }
}
